<template>
  <div class="vx-row mx-2 shipment-document-create-page">

    <vx-card titleColor="#736F6E" title="" class="my-8" no-shadow>
      <vs-row vs-w="12" class="mt-8">
        <vs-col v-for="(social, index_contact) in documents" :key="index_contact"
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
                vs-lg="6" vs-sm="6" vs-xs="12"
                class="px-4 pb-4">
          <vx-card-custom :cardBorder="true" no-shadow  v-on:remove="onDeleteDoc(index_contact)" :remove-card-action="true"  :collapse-action="false">
            <div class="vx-row mb-2">
              <div class="vx-col md:w-1/2 w-full md:mb-0">
                <ValidationProvider  :vid="index_contact+'type'" :name="index_contact+'type'" rules="required" v-slot="{ errors }">
                  <small class="label">Type</small>
                  <v-select
                    class="dropdown-menu"
                    :appendToBody="true"
                    calculatePosition="top"
                    :clearable="false" name="type"
                    placeholder=""
                    v-model="social.type"
                    :options="['Proof of Delivery', 'Dispatch Note', 'DHL Shipment Label']"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
                </ValidationProvider>
              </div>
              <div class="vx-col md:w-1/2 w-full md:mb-0">
                <ValidationProvider  :vid="index_contact+'file'" :name="index_contact+'file'" rules="required" v-slot="{ errors }">
                  <small class="label">File (max 25mb | .pdf .jpeg .png .xlx .doc .docx)</small>
                  <file-uploader-not-required
                    v-on:onSetFileName="value => social.url = value"
                    v-on:onClickFileRemove="social.url = null"
                    :file="social.url"
                    :condition="true"/>
                </ValidationProvider>
              </div>
              <div class="vx-col md:w-full w-full md:mb-0">
                <ValidationProvider  :vid="index_contact+'url'" :name="index_contact+'url'" rules="required" v-slot="{ errors }">
                  <small class="label">Description</small>
                  <vs-input v-model="social.description"   name="description" class="w-full required" label=""/>
                </ValidationProvider>
              </div>
            </div>

          </vx-card-custom>
        </vs-col>
      </vs-row>
      <vs-button class="mt-4 mb-4 ml-4" @click="onAddDoc()" size="small" color="success" type="filled" icon-pack="feather" icon="icon-plus">Add new document</vs-button>
    </vx-card>

<!--    <div style="min-height: 90% !important" class="vx-col md:w-full w-full md:mb-0">-->
<!--      <vs-button @click="onAddDoc()" button="submit" size="" color="primary" class="ml-auto mt-2 mb-4">Add new file</vs-button>-->
<!--      <vs-table  stripe :data="documents">-->

<!--        <template slot="thead">-->
<!--          <vs-th>Document Type</vs-th>-->
<!--          <vs-th>Document</vs-th>-->
<!--          <vs-th>Description</vs-th>-->
<!--          <vs-th>Action</vs-th>-->
<!--        </template>-->

<!--        <template slot-scope="{data}">-->
<!--          <vs-tr :key="indextr" v-for="(tr, indextr) in data">-->

<!--            <vs-td :data="data[indextr].type">-->
<!--              <v-select-->
<!--                class="dropdown-menu"-->
<!--                        :appendToBody="true"-->
<!--                        calculatePosition="top"-->
<!--                        :clearable="false" name="type"-->
<!--                        placeholder=""-->
<!--                        v-model="data[indextr].type"-->
<!--                        :options="['Proof of Delivery', 'Dispatch Note']"-->
<!--                        :dir="$vs.rtl ? 'rtl' : 'ltr'"/>-->
<!--            </vs-td>-->

<!--            <vs-td :data="data[indextr].url">-->
<!--              <file-uploader-not-required-->
<!--                v-on:onSetFileName="value => data[indextr].url = value"-->
<!--                v-on:onClickFileRemove="data[indextr].url = null"-->
<!--                :file="data[indextr].url"-->
<!--                :condition="true"/>-->
<!--            </vs-td>-->

<!--            <vs-td :data="data[indextr].description">-->
<!--              <vs-input v-model="data[indextr].description"   name="description" class="w-full required" label=""/>-->
<!--            </vs-td>-->

<!--            <vs-td >-->
<!--              <div class="vx-row">-->
<!--                <vx-tooltip text="Remove File" position="left">-->
<!--                  <vs-button class="ml-3" @click="onDeleteDoc(indextr)"-->
<!--                             size="small" color="danger" type="border" icon-pack="feather" icon="icon-delete"></vs-button>-->
<!--                </vx-tooltip>-->
<!--              </div>-->
<!--            </vs-td>-->

<!--          </vs-tr>-->
<!--        </template>-->

<!--      </vs-table>-->
    <div class="flex flex-wrap items-center justify-end mt-8">
      <vs-button @click="onClickSave" button="submit" class="ml-auto mt-2">Save Changes</vs-button>
    </div>
<!--    </div>-->
  </div>
</template>

<script>
import {RepositoryFactory} from '@/repository/RepositoryFactory'
import vSelect from 'vue-select'
const CourierRepository = RepositoryFactory.get('courier')
import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'

export default {
  name: "ShipmentDocumentView",
  data() {
    return {
      documents: [
        { courier_shipment_id: this.shipment_id, type: '', url: '', description: '' }
      ]
    }
  },
  mixins : [SuccessMessage, ErrorMessages],
  components: {
    'v-select': vSelect,
  },
  props: {
    shipment_id: {type: Number}
  },
  async mounted() {
    // await this.fetchShipmentDocuments()
  },
  methods: {
    async fetchShipmentDocuments() {
      const {data} = (await CourierRepository.getShipmentDocuments(this.shipment_id)).data
      this.documents = data
    },
    onAddDoc() {
      this.documents.push(  { courier_shipment_id: this.shipment_id, type: '', url: '', description: '' } )
    },
    onDeleteDoc(index) {
      this.documents.splice(index, 1)
    },
    async onClickSave() {
      try {
        await CourierRepository.createShipmentDocuments({documents: this.documents})
        this.$emit('onSuccessDocumentUpload', '')
        this.showSuccessMessage('Document uploaded!')
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    }
  },
  watch: {
    shipment_id: {
      deep: true,
      handler() {

      }
    }
  },
}
</script>

<style scoped>
.shipment-document-create-page >>> .vs-popup {
  /*min-height: 50% !important;*/
  min-width: 70% !important;
}
.dropdown-menu {
  z-index:10030 !important;
}
</style>
